import {useSelector} from "react-redux";
import {Lessons} from "redux/reducers/lessonsSlice";
import {RootSliceType} from "redux/reducers/rootReducer";
import {IPoints} from "../reducers/pointsSlice";

export const usePointsSelector = () => {
  const points = useSelector<RootSliceType, IPoints["points"]>(
    (state) => state.points.points
  );
  const loading = useSelector<RootSliceType, Lessons["loading"]>(
    (state) => state.points.loading
  );


  return {
    points,
    loading
  };
};

export default usePointsSelector;
